import comp from "./ResourceCard";
export default comp;
